import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';
import { Form } from 'react-bootstrap';
import logo from '../assets/logo.png';
import './SupplierRegister.css';

const ContractorRegister = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    mobile: '',
    email: '',
    password: '',
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate('/'));

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mobile') {
      setFormData({ ...formData, mobile: value.replace(/\D/g, '').slice(0, 15) });
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!/^\d{10,15}$/.test(formData.mobile)) {
      setError('Valid mobile number required (10-15 digits)');
      return;
    }
    if (String(formData.password || '').length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    try {
      const res = await API.post('/auth/register/contractor', formData);
      setMessage(res.data.message);
      setTimeout(() => navigate('/'), 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div className="supplier-shell">
      <header className="supplier-topbar">
        <div className="topbar-left">
          <button className="topbar-back" type="button" onClick={goBack} aria-label="Go back">
            <span className="material-symbols-outlined">arrow_back_ios_new</span>
          </button>
          <div className="brand">
            <img src={logo} alt="Lotus Rice Mill Pvt. Ltd." className="brand-logo" />
            <span>Lotus Rice Mill Pvt. Ltd.</span>
          </div>
        </div>
        <button className="topbar-btn" type="button" onClick={() => navigate('/')}>Login</button>
      </header>

      <main className="supplier-main">
        <div className="supplier-card">
          <div className="supplier-header">
            <h1>👷 Contractor Registration</h1>
            <p>Register as mill contractor partner</p>
          </div>

          {message && <div className="supplier-message success">{message}</div>}
          {error && <div className="supplier-message error">{error}</div>}

          <Form onSubmit={handleSubmit} className="supplier-form">
            <div className="grid">
              <label>
                Full Name
                <input name="fullName" value={formData.fullName} onChange={handleChange} placeholder="e.g. Ramesh Kumar" required />
              </label>
              <label>
                Mobile
                <input
                  name="mobile"
                  type="tel"
                  inputMode="numeric"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="e.g. 9876543210"
                  required
                />
              </label>
            </div>

            <label>
              Email Address
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="name@company.com" required />
            </label>

            <label>
              Password
              <div className="password-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Minimum 6 characters"
                  required
                />
                <button
                  type="button"
                  className="supplier-password-toggle"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label="Toggle password visibility"
                >
                  <span className="material-symbols-outlined">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </label>

            <button className="primary-btn" type="submit">Register</button>
          </Form>

          <div className="supplier-footer">
            Already have an account? <button type="button" onClick={() => navigate('/')}>Login here</button>
          </div>
        </div>
      </main>

      <footer className="supplier-bottom">
        © 2024 Lotus Rice Mill Pvt. Ltd. All rights reserved.
      </footer>
    </div>
  );
};

export default ContractorRegister;
